import { Component, OnInit } from '@angular/core';
import {getUser, setUser, setToken} from '../../assets/utils.js';
import {Router} from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent {

  constructor(private router: Router) {
      setUser(null);
      setToken(null);
      this.router.navigate(['/login']);
  }

}
